var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layoutContainer" },
    [
      _vm.setNav() ? _c("PublicNav") : _c("TopMenu"),
      _vm._v(" "),
      _c("router-view", { key: _vm.key }),
      _vm._v(" "),
      _vm.setFoter() ? _c("PublicFooter") : _vm._e(),
      _vm._v(" "),
      _c("LoginPopup"),
      _vm._v(" "),
      _c("RegisterPopup"),
      _vm._v(" "),
      _c("ForgetPassPopup")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-13877386", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13877386","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/index.vue
// module id = null
// module chunks = 